module.exports = __webpack_public_path__ + "static/assets/c8d844644e23434c50cf7fa6a78f8f6e.png";